import * as Yup from "yup";

import { TextManager } from "Components/TextContext/TextManager";
import { BooleanFormType } from "Store/interfaces/FormTypes";
import { PepFormValues } from "./interfaces";

export type IPepValidationObject = {
  pep: Yup.MixedSchema<BooleanFormType>;
};

export const pepValidationObject = (): IPepValidationObject => {
  return {
    pep: Yup.mixed<BooleanFormType>()
      .oneOf([BooleanFormType.FALSE], "")
      .required(
        TextManager.getText("citizenshippepform.validation.pep_required"),
      ),
  };
};

export const pepValidationSchema = (): Yup.ObjectSchema<PepFormValues> => {
  return Yup.object(pepValidationObject()).defined();
};
